// @owners { team: patients }
import { getCashLessThanInsuranceSavings } from '~shared/features/checkout/helpers';
import { useCartSelectedPricingInfoForPrescription } from '~shared/features/prescriptions/hooks/useCartSelectedPricingInfoForPrescription';
import { formatDollars } from '~shared/helpers/currency';

export const useSavingsAppliedDescriptions = (prescriptionID: number) => {
  const { prescriptionPricingInfo, priceOptions, savingsAppliedAmount } = useCartSelectedPricingInfoForPrescription({
    prescriptionID,
  });
  const { paymentType } = prescriptionPricingInfo || {};
  const cashSavingsText = getCashLessThanInsuranceSavings(priceOptions);

  const savingsDescriptions: string[] = [];
  if (cashSavingsText && paymentType === 'without_insurance') {
    savingsDescriptions.push(cashSavingsText);
  }

  if (savingsAppliedAmount) {
    savingsDescriptions.push(`Savings Applied -${formatDollars(savingsAppliedAmount)}`);
  }
  return savingsDescriptions;
};
